import logo from './logo.svg';
import './App.css';
import Flourish from './Policies/Flourish';
import {Routes, Route, useLocation} from 'react-router-dom'
import Ignition from './Policies/Ignition';
import ScriptureChat from './Policies/ScriptureChat';
import AiSPY from './Policies/AISpy';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/Flourish" element={<Flourish />}/>
        <Route path="/Ignition" element={<Ignition />}/>
        <Route path="/ScriptureChat" element={<ScriptureChat />}/>
        <Route path="/ai-spy" element={<AiSPY />}/>
      </Routes>
    </div>
  );
}

export default App;
